import { z } from 'zod';
export const institutionOwnMailOptionsSchema = z
    .object({
    programmeId: z.string().uuid(),
    limit: z.number().int().min(1).max(20).default(20),
    before: z
        .object({ at: z.string().datetime({ offset: true }), id: z.string().uuid() })
        .strict()
        .optional(),
})
    .strict();
export const institutionOwnMailLinkSchema = z
    .object({
    key: z.string().uuid(),
    programmeId: z.string().uuid(),
    sourceId: z.string().uuid(),
    confirmed: z.literal(true),
})
    .strict();
/** Shared programme note, deliberately containing none of the private source's fields. */
export const INSTITUTION_OWN_MAIL_NOTE = 'A person selected a private mirrored sent-mail reference. Its content and original identifiers remain private. This note does not verify current provider state, completed contact, submission or acceptance.';
//# sourceMappingURL=institution-own-mail.js.map